import React from "react";
import { Link } from "react-router-dom";

const ScreensTable = ({ data }) => {
  return (
    <table className="table">
      <thead>
        <tr>
          <th>Screen Name</th>
          <th>Site</th>
        </tr>
      </thead>
      <tbody>
        {data.map((screen) => (
          <tr key={screen.ID}>
            <td>
              <Link to={`/dataentry/manage/${screen.ID}`}>
                {screen.DESCRIPTION}
              </Link>
            </td>
            <td>{screen.SITE}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ScreensTable;
